import { createContext, useState } from "react";
import Category from "../../../api/Stockroom/Category";
import ModalSimpleButton from "../../../components/Modal/ModalSimpleButton";
import { useEffect } from "react";
import { Typography } from "@mui/material";

export const CategoryContext = createContext(null);

export const CategoryContextProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [hasError, setHasError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (hasError) setIsModalOpen(true);
  }, [hasError]);

  const getAllCategories = async () => {
    await Category.getAll()
      .then((data) => {
        setCategories(data);
      })
      .catch((err) => {
        setHasError(err);
        setIsModalOpen(true);
      });
  };

  const getCategoryByName = async (categoryName) => {
    await Category.getCategoryByName(categoryName)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        setHasError(err);
        setIsModalOpen(true);
      });
  };

  return (
    <CategoryContext.Provider
      value={{ categories, getCategoryByName, getAllCategories }}
    >
      {children}
      <ModalSimpleButton
        title={"Error"}
        buttonText={"Close"}
        buttonAction={() => {
          setIsModalOpen(false);
          setHasError("");
        }}
        setOpen={() => {
          setIsModalOpen(false);
          setHasError("");
        }}
        open={isModalOpen}
      >
        <Typography
          style={{ padding: "0 16px", fontSize: 18, textAlign: "center" }}
        >
          {hasError}
        </Typography>
      </ModalSimpleButton>
    </CategoryContext.Provider>
  );
};
